'use strict';

/**
* @ngdoc controller
* @name tcApp.controllers:ActiveClinicalNotesCtrl
* @description
* ACN controller.
*
*/

angular.module('tcApp')
.value('acnData', null)
.controller('ActiveClinicalNotesCtrl', function($scope, $window, $document, $location, $route, $log,
												acnData, GlobalService, SystemRouter, ElementStateService) {
	if (acnData != null) {
		$scope.data = acnData.data;
	}
	if (angular.isUndefined($scope.data)) $scope.data = {};
	$scope.globalStrings = GlobalService.getGlobalStrings();
	$scope.viewModel = {
		acnHtmlName: 'tc_ACN',
		displayActions: false,
		displayNotes: false,
		displayChart: false,
		displayTabComponent: false,
		currentTabHasButtons: false,
		chartIsLoading: false
	};
	
	// Store whether components have buttons so we can leave margin for button bar when they are shown
	var headerHasButtons = angular.isDefined($scope.data.headerComponent.data.componentHasButtons);
	var actionsHasButtons = angular.isDefined($scope.data.actionsComponent.data.componentHasButtons);
	var notesHasButtons = angular.isDefined($scope.data.notesComponent.data.componentHasButtons);
	
	// This value updated based on button data from visible components when changing tabs
	$scope.viewModel.currentTabHasButtons = ((headerHasButtons) || (actionsHasButtons) || (notesHasButtons));

	$log.debug('acnCtrl ' + $scope.viewModel.acnHtmlName + ': ', $scope.data);
	
	var initialiseCtrl = function() {
		$document.ready(function() {
			$scope.scrollToNewItem();
		});
	};
	
	// Reloads the ACN, triggered from component scripts within ACN
	$scope.reload = function(url) {
		if (url == $location.url()) {
			$route.reload();
		} else {
			$location.url(url).replace();
		}
	};
	
	var getEncounterParams = function() {
		// TODO: Only pass through tab name because this stuff will be set in the Msg class
		return ('&ID=' + $scope.data.encounterId +
				'&MREncounterID=' + $scope.data.encounterId +
				'&MREncEntryID=' + $scope.data.entryId +
				'&MREncEntryTypeID=' + $scope.data.entryTypeId);
	};
	
	$scope.showChart = function(chartBookId, chartId, chartItemId) {
		var params = $route.current.params;
		$scope.viewModel.chartIsLoading = true;
		SystemRouter.fetchChartData($scope.data.chartBook.id, chartId, chartItemId, params).then(function(response) {
			$scope.data.chartBook.data = response.data;
			$scope.viewModel.displayChart = true;
			$scope.viewModel.displayActions = false;
			$scope.viewModel.displayNotes = false;
			$scope.viewModel.displayTabComponent = false;
			$scope.viewModel.chartIsLoading = false;
			if (!headerHasButtons) GlobalService.updateButtonBar(false);
			
		});
	};
	
	$scope.showCurrent = function(tab, tabSwitching) {
		// Don't get data again on load
		if (tabSwitching) {
			var notesComponentName = $scope.data.notesComponentHtmlName;
			var actionsComponentName = $scope.data.actionsComponent.name.replace(/\./g, '_') + '_0';
			var params = getEncounterParams();
			params += '&tab=' + tab.name + '&CurrentEntryOnly=' + $scope.data.entryId;
			GlobalService.reloadComponent(actionsComponentName, params);
			GlobalService.reloadComponent(notesComponentName, params, function() {
				$scope.viewModel.displayChart = false;
				$scope.viewModel.displayActions = true;
				$scope.viewModel.displayNotes = true;
				$scope.viewModel.displayTabComponent = false;
				GlobalService.updateButtonBar($scope.viewModel.currentTabHasButtons);
			});
		} else {
			$scope.viewModel.displayChart = false;
			$scope.viewModel.displayActions = true;
			$scope.viewModel.displayNotes = true;
		}
	};
	
	// Should not be called. Left in to avoid error
	$scope.showNewItemList = function() {
		$scope.viewModel.displayChart = false;
		$scope.viewModel.displayActions = false;
		$scope.viewModel.displayNotes = false;
	};
	
	$scope.scrollToNewItem = function() {
		var newEntryElem = $window.document.querySelector('.clsNewEntryItem');
		if (newEntryElem) {
			GlobalService.scrollToElement(newEntryElem, 0, ($scope.viewModel.acnHtmlName + '-notes'));
		}
	};

	$scope.toggleActions = function() {
		$scope.viewModel.actionsHidden = !$scope.viewModel.actionsHidden;
	};
		
	// params passed in to from TabControl Parameter function
	$scope.showTabComponent = function(tab, params, compItemName) {
		$scope.viewModel.displayTabComponent = false;
		$scope.data.tabComponent.name = tab.componentName;
		
		// Don't pass blank parameters to avoid conflicting with default values
		angular.forEach(params, function(value, key) {
			if (value === '') delete params[key];
		});
		
		// Construct the new parameters based on the current route and passed parameters
		var newParameters = angular.extend({}, $route.current.params,
		params, {componentName: tab.componentName});
		var uniqueIndexPrefix = (compItemName + (tab.index - 1));

		SystemRouter.fetchComponentData(tab.componentName, newParameters, undefined, uniqueIndexPrefix)
			.then(function(response) {
				$scope.data.tabComponent.data = response.data;
				$scope.viewModel.displayChart = false;
				$scope.viewModel.displayActions = false;
				$scope.viewModel.displayNotes = false;
				$scope.viewModel.displayTabComponent = true;
				if (!headerHasButtons) {
					var tabComponentHasButtons = angular.isDefined($scope.data.tabComponent.data.componentHasButtons);
					GlobalService.updateButtonBar(tabComponentHasButtons);
				}
			});
	};
	
	$scope.selectTab = function(tab, compItem, compItemName, tabSwitching, params) {
		var requestParametersObject = GlobalService.urlToObject(params);
		// Clear default tab Parameters so ACN tabs do not restore tabControl request Data
		requestParametersObject.tkTabControlName = '';
		requestParametersObject.tkTabName = '';
		
		if (tab.componentName) {
			$scope.showTabComponent(tab, requestParametersObject, compItemName);
		} else if (tab.name === 'Current') {
			$scope.showCurrent(tab, tabSwitching);
		} else if (tab.name === 'EPR') {
			var selectedChart = ElementStateService.get('embeddedSelectedChart', angular.toJson($route.current.params));
			var selectedChartItem = ElementStateService.get('embeddedSelectedChartItem', angular.toJson($route.current.params));
			// Prevent loading EPR again if tab selection is triggered multiple times
			if (!$scope.viewModel.chartIsLoading) {
				$scope.showChart($scope.data.chartBook.id, selectedChart, selectedChartItem);
			}
		}
	};

	$scope.$on('Global:userLogon', function(event, sessionData) {
		$scope.globalStrings = sessionData.globalStrings;
	});

	$scope.$on('Global:callFunction', function(event, componentHtmlName, 
		functionName, args, callbackFunction) {
		if (componentHtmlName !== 'ACN') return;
	
		if (angular.isFunction($scope[functionName])) {
			var returnValue = $scope[functionName].apply(this, args);
			if (angular.isFunction(callbackFunction)) callbackFunction(returnValue);
		} else {
			$log.warn('Could not find function ', functionName, ' in ', componentHtmlName, ' controller');
		}
	});
	
	if ($scope.data.bannerData) GlobalService.updateBannerData($scope.data.bannerData);
	
	initialiseCtrl();
});
